import React from "react";

/*eslint-disable */

declare const window: any;
const DescriptionComponent: React.FC = () => {
  return (
    <div className="hojas-rescate-component">
      Aquí puedes encontrar las fichas de seguridad para la selección de
      vehículos Hyundai. Esta información puede ser útil exclusivamente en casos
      de emergencia para que el personal de seguridad y campo atiendan. Para
      acceder a estas hojas de rescate para nuestros modelos, por favor
      refiérase a esta sección.
    </div>
  );
};

export default DescriptionComponent;
